import ChainGeneralInfo from './ChainGeneralInfo';

export default ChainGeneralInfo;
